import script from "./cpt-suspension.vue?vue&type=script&setup=true&lang=js"
export * from "./cpt-suspension.vue?vue&type=script&setup=true&lang=js"

import "./cpt-suspension.vue?vue&type=style&index=0&id=2d071bc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d071bc6"]])

export default __exports__